import Button from '@viking-eng/button';
import Close from '@viking-eng/icon/lib/Close';
import HamburgerMenu from '@viking-eng/icon/lib/HamburgerMenu';
import Menu from '@viking-eng/menu';
import PropTypes from '@viking-eng/prop-types';
import { getAccessibilityFunctions, getScreenTier, prepareHtml } from '@viking-eng/utils';
import classNames from 'classnames';
import $ from 'jquery';
import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { Link } from 'react-router-dom';
import './Header.css';

// Header component for showing headers
// Cookiemessage to show cookie description for UK territory
// Children to show top right header menu

function Header({
  additionalMenus,
  children,
  cookieMessage,
  header: { logo, items, country, navigationRoute },
  headerClass,
  onCookieClose,
  preHeaderButton,
  preHeaderText
}) {
  $(document).ready(() => {
    const cookieButton = document.getElementsByClassName('cookie-button')[0];
    if (cookieButton) {
      cookieButton.setAttribute('tabindex', '1');
    }
  });

  const cookieButtonText = (
    <div>
      <span className="close-text">CLOSE</span>
      <Close />
    </div>
  );

  const headerIconNavigationRoute = country ? `/${country}` : navigationRoute;
  const hasLeftMenu = items && !!items.length;

  const screenTier = getScreenTier();

  return (
    <header className="header-wrapper">
      <div className={classNames('header', headerClass)}>
        {cookieMessage && (
          <div role="button" className="cookie-header small-body-copy">
            <CookieConsent
              buttonClasses="cookie-button"
              buttonText={cookieButtonText}
              contentClasses="cookie-content"
              cookieName="vikingUKCookie"
              disableStyles
              expires={90}
              location="none"
              onAccept={onCookieClose}
            >
              <span dangerouslySetInnerHTML={prepareHtml(cookieMessage)} />
              {/* eslint-disable jsx-a11y/tabindex-no-positive */}
              <a
                {...getAccessibilityFunctions()}
                className="privacy-link"
                data-toggle="modal"
                href="#privacyPolicy"
                rel="noopener noreferrer"
                tabIndex="1"
              >
                privacy notice
              </a>
              <span>.</span>
            </CookieConsent>
          </div>
        )}
        {preHeaderText && (
          <div className="preheader-container row no-gutters">
            {preHeaderButton && (
              <Button className="col-4 header-link" appearance="link" onButtonClick={preHeaderButton.onClick}>
                {preHeaderButton.text}
              </Button>
            )}
            <div className={classNames('container text-center', { 'col-4': preHeaderButton })}>{preHeaderText}</div>
            {preHeaderButton && <div className="col-4" />}
          </div>
        )}
        <div className={classNames(`header-container ${preHeaderText ? 'has-pre-header' : ''}`)}>
          <div className="container menu">
            <nav className="navbar row no-gutters">
              <div className="col-sm-4 col-md col-1">
                {hasLeftMenu && (
                  <Button
                    attributes={{
                      'data-toggle': 'collapse',
                      'data-target': '#leftMenuId',
                      'aria-haspopup': 'true',
                      'aria-expanded': 'false',
                      'aria-label': 'Toggle navigation',
                      tabIndex: '0',
                      id: 'hamburger-menu'
                    }}
                    appearance="icon"
                    inlineCss={{
                      color: 'White',
                      fontSize: '16px',
                      marginBottom: '4px'
                    }}
                    onButtonClick={(e) => {
                      if (screenTier === 'extra-small') {
                        document.body.classList.toggle('left-menu-open');
                        e.preventDefault();
                      }
                    }}
                  >
                    <HamburgerMenu />
                  </Button>
                )}
              </div>

              <div className="logo col-sm-4 col-md col-5">
                <Link
                  to={headerIconNavigationRoute || '/myjourney'}
                  className="logo-column"
                  tabIndex="0"
                  {...getAccessibilityFunctions()}
                >
                  <img className="logo-image" src={logo} alt="logo" />
                </Link>
              </div>
              <div className="col-sm-4 col-md col-5">
                <div className="no-gutters header-right">{children}</div>
              </div>
            </nav>
            {hasLeftMenu && <Menu items={items} id="leftMenuId" />}
            {additionalMenus.map((menu) => (
              <div className="additional-menu" key={menu.id}>
                <Menu id={menu.id} items={menu.items} tabIndex={menu.tabIndex} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
}

Header.propTypes = {
  additionalMenus: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      items: PropTypes.menuItems
    })
  ),
  children: PropTypes.jsx,
  cookieMessage: PropTypes.string,
  header: PropTypes.shape({
    country: PropTypes.string,
    items: PropTypes.array.isRequired,
    logo: PropTypes.string.isRequired,
    navigationRoute: PropTypes.string
  }),
  headerClass: PropTypes.string,
  onCookieClose: PropTypes.func,
  preHeaderText: PropTypes.string,
  preHeaderButton: PropTypes.shape({
    onClick: PropTypes.func,
    text: PropTypes.string
  })
};

Header.defaultProps = {
  additionalMenus: [],
  children: null,
  cookieMessage: '',
  header: {},
  headerClass: '',
  onCookieClose: () => {},
  preHeaderButton: {
    onClick: null,
    text: ''
  },
  preHeaderText: null
};

export default Header;
